/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* Neeve: remember the last moment the visitor clicked, tapped or typed,
   so the pop-up never opens in the middle of choosing a size or adding to cart. */
window.neeveLastInteraction = window.neeveLastInteraction || 0;
['pointerdown', 'keydown', 'touchstart'].forEach((type) => {
  document.addEventListener(type, () => { window.neeveLastInteraction = Date.now(); }, { capture: true, passive: true });
});

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!getCookie(this.cookie) && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            this.open();
          } else if (this.dataset.trigger === 'delay') {
            setTimeout(() => this.openWhenIdle(), Number(this.dataset.delay) * 1000);
          } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          }
        }
      }

      /**
       * Neeve: only open when the visitor is not busy. Not on the cart page,
       * not while the cart drawer is open, and not within 4 seconds of a click or tap.
       */
      openWhenIdle() {
        if (getCookie(this.cookie)) return;
        if (/\/cart\/?$/.test(window.location.pathname)) return;

        const drawer = document.querySelector('cart-drawer');
        const drawerOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
        const recentlyActive = Date.now() - window.neeveLastInteraction < 4000;

        if (drawerOpen || recentlyActive) {
          setTimeout(() => this.openWhenIdle(), 3000);
          return;
        }

        this.open();
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie)) this.open();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        setCookie(this.cookie, true, parseInt(this.dataset.dismissDays, 10));
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
